'use strict';

var NewExtractCalendarSubpanelDirective = function NewExtractCalendarSubpanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/new-extract-calendar-subpanel.html'),
    requires: '^rmDataExtractNewExtract'
  };
};
NewExtractCalendarSubpanelDirective.$inject = [];
module.exports = NewExtractCalendarSubpanelDirective;